import {
    Dialog,
    DialogActions,
    DialogContent,
    IconButton,
    styled,
} from "@mui/material";

export const StyledDialog = styled(Dialog, {
    shouldForwardProp: (prop) =>
        prop !== "modalInnerContainerStyles" &&
        prop !== "isMobileApp" &&
        prop !== "inputFocused" &&
        prop !== "isBorderRadiusVisible",
})<{
    isMobileApp?: boolean;
    inputFocused?: boolean;
    modalInnerContainerStyles?: object;
    isBorderRadiusVisible: boolean;
}>(
    ({
        modalInnerContainerStyles,
        isMobileApp = false,
        inputFocused = false,
        isBorderRadiusVisible,
    }) => ({
        "& > .MuiDialog-container > .MuiPaper-root": {
            margin: 0,
            borderRadius: isBorderRadiusVisible ? "12px" : 0,
            maxHeight: "none",
            maxWidth: "none",
            height: "100%",
            width: "100%",
            "@media (max-width: 639px)": {
                borderTopLeftRadius: isBorderRadiusVisible && "12px",
                borderTopRightRadius: isBorderRadiusVisible && "12px",
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
                position: "absolute",
                width: "100%",
                maxWidth: "unset",
                bottom: 0,
                paddingBottom:
                    isMobileApp && !inputFocused
                        ? "var(--safe-area-inset-bottom)"
                        : 0,
            },
            "@media (min-width: 640px)": {
                overflowY: "unset",
                width: "75vh",
                maxHeight: "680px",
                maxWidth: "540px",
                borderRadius: "12px",
            },
            ...modalInnerContainerStyles,
        },
    }),
);

export const StyledDialogContent = styled(DialogContent, {
    shouldForwardProp: (prop) =>
        prop !== "isBorderRadiusVisible" && prop !== "isPaddingVisible",
})<{ isBorderRadiusVisible: boolean; isPaddingVisible: boolean }>(
    ({ isBorderRadiusVisible, isPaddingVisible }) => ({
        borderRadius: isBorderRadiusVisible ? "12px" : 0,
        height: "100%",
        padding: isPaddingVisible ? "16px" : 0,
    }),
);

export const StyledDialogActions = styled(DialogActions)({
    position: "relative",
    padding: "0",
});

export const OutsideModalIconButton = styled(IconButton)({
    position: "absolute",
    right: 8,
    top: "-45px",
    color: "#FFF",
});
